module.exports = __webpack_public_path__ + "static/media/Mast_CBD_retina.2fa9ce74.jpg";